import { useEffect, useState } from "react";
import { isKickStaffEmail } from "@common/helpers/kickStaff";
import {
    type DemoFeatureFlagScope,
    useDemoFeatureFlagScope,
} from "@hooks/useDemoFeatureFlagScope";
import { useUser } from "@hooks/useUser";

const openers = new Set<() => void>();

export function requestOpenFeatureFlagsPanel(): void {
    for (const open of openers) {
        open();
    }
}

export function subscribeFeatureFlagsPanel(open: () => void): () => void {
    openers.add(open);
    return () => {
        openers.delete(open);
    };
}

export function useDemoFeatureFlagsTarget(): DemoFeatureFlagScope | null {
    const user = useUser();
    const scope = useDemoFeatureFlagScope();

    return isKickStaffEmail(user?.email) ? scope : null;
}

export function useCanShowDemoFeatureFlags(): boolean {
    return useDemoFeatureFlagsTarget() !== null;
}

export function useFeatureFlagsPanelOpen(): {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
} {
    const canShow = useCanShowDemoFeatureFlags();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => subscribeFeatureFlagsPanel(() => setIsOpen(true)), []);

    useEffect(() => {
        if (!canShow) {
            setIsOpen(false);
        }
    }, [canShow]);

    return { isOpen, onOpenChange: setIsOpen };
}
